import { useRootAppStore } from "@hooks";
import { getCurrentCulture } from "@utils";
import { useDocumentExpiration } from "@state/hooks/document-expiration/useDocumentExpiration";
import React from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";

export default function DocumentExpirationInfo() {
	const { t } = useTranslation("document-expiration");
	const rootStore = useRootAppStore();
	const data = useDocumentExpiration();
	if (!data) {
		return null;
	}

	return (
		<div className="popup__col col col-sml-12">
			<div className="message message--base">
				<div className="message__content u-padd--reset">
					<div className="message__title u-type--xmed">
						<i className="message__icon u-icon u-icon--lrg u-icon--user-unverified u-color--sent--warning u-mar--right--tny" />
						<span className="u-align--v--middle">{t("TITLE")}</span>
					</div>

					<ReactMarkdown className="message__text">
						{t(`${data.message}`)}
					</ReactMarkdown>

					<Link
						className="at-welcomeModalBtnVerif u-anchor u-anchor--warning u-anchor--underline has-arrow"
						to={`/${getCurrentCulture()}/account-settings/document-expiration`}
						onClick={() => {
							rootStore.welcomeStore.hidePopup(),
								rootStore.requiredUserActionStore.hidePopup();
						}}
					>
						{t("TITLE")}
					</Link>
				</div>
			</div>
		</div>
	);
}
